import React from 'react';
import { Formik } from 'formik';

import { Loading } from 'components/shared/Loading';

import { MainLayout } from 'components/Layout';
import { BreadcrumbsToolbar } from 'components/Toolbar';
import { AutoSave } from 'components/AutoSave';
import { ToolbarActions } from 'components/ToolbarActions';
import { FormikField } from 'components/FormikField';
import { InputField } from 'components/FormikFields';

import { convertDataToForm } from './LessonCategoryPage.helpers';

import styles from './LessonCategoryPage.module.scss';

const LessonCategoryPage = ({
  loading,
  isRootAdmin,
  saveLoading,
  autoSaveLoading,
  readOnly,
  category,
  onAutoSaveSubmit,
  onSaveClick,
}: {
  loading: any;
  isRootAdmin: any;
  saveLoading: any;
  autoSaveLoading: any;
  readOnly: any;
  category: any;
  onAutoSaveSubmit: any;
  onSaveClick: any;
}) => (
  <Formik
    enableReinitialize
    validateOnMount
    initialValues={convertDataToForm(category)}
    onSubmit={onAutoSaveSubmit}
  >
    {({ values }: { values: any }) =>
      loading ? (
        <Loading />
      ) : (
        <MainLayout
          toolbarComponent={
            <BreadcrumbsToolbar
              breadcrumbsData={{
                categoryName: values.name,
              }}
              endAdornment={
                <ToolbarActions
                  saveLoading={saveLoading}
                  isRootAdmin={isRootAdmin}
                  contextItems={[]}
                  withPreview={false}
                  autoSaveLoading={autoSaveLoading}
                  onSaveClick={() => onSaveClick(values)}
                />
              }
            />
          }
        >
          <div className={styles.page}>
            <AutoSave debounceMs={1000} />

            <FormikField
              name="name"
              withControl={false}
              component={InputField}
              componentProps={{
                readOnly,
                className: styles.name,
              }}
            />
          </div>
        </MainLayout>
      )
    }
  </Formik>
);

export default React.memo(LessonCategoryPage) as any;
